// extracted by mini-css-extract-plugin
module.exports = {"root":"_2s-pR","link":"_3CGW1"};